import { styled } from '@pulse-web-ui/theme';

export const DescriptionContainer = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 28px;
  white-space: pre-line;
`;
